import { sv } from 'vuetify/src/locale'

// För att kodningen ska vara rätt: åäö

export default {
    ...sv,
    narvaroGo: "NärvaroGo",
    version: "Version",
    accessibilityStatement: "Tillgänglighetsredogörelse",
    id: "Id",
    created: "Skapad",
    createdBy: "Skapad av",
    register: 'Registrera',
    modify: 'Ändra',
    modified: "Ändrad",
    modifiedBy: "Ändrad av",
    updated: "Uppdaterad",
    updatedBy: "Uppdaterad av",
    search: "Sök",

    login: "Logga in",
    logout: "Logga ut",
    password: "Lösenord",
    emailAddress: "Epostadress",

    required: "Obligatoriskt",
    information: "Information",
    errormessage: "Felmeddelande",
    message: "Meddelande",
    add: "Lägg till",
    new: "Ny",
    create: "Skapa",
    save: "Spara",
    cancel: "Avbryt",
    delete: "Ta bort",
    edit: "Ändra",
    change: "Ändra",
    close: "Stäng",
    choose: "Välj",
    chooseAll: "Välj alla",
    ok: "Ok",

    to: "Till",
    from: "Från",

    yes: "Ja",
    no: "Nej",

    savedAll: "Allt sparat",
    savedChanges: "Ändringar sparade",
    saved: "Sparad",
    saving: "Sparar",
    savedValues: "Sparade värden",
    update: "Uppdatera",

    date: "Datum",
    dateFrom: "Datum från",
    dateTo: "Datum till",

    time: "Tid",
    timeFrom: "Tid från",
    timeTo: "Tid till",

    invalidEmail: "Ogiltig e-postadress",
    invalidZipCode: "Ogiltigt postnummer",
    formatSSN: "Anges i format ÅÅÅÅMMDD-XXXX",
    invalidSSN: "Ogiltigt personnummer",
    invalidOrgNo: "Ogiltigt organisationsnummer",

    mustBeAfter: " måste vara efter ",

    generalErrorMessage: "Något gick fel!",

    deleteDialogMessage: "Är du säker på att du vill ta bort",

    name: "Namn",
    role: "Roll",

    female: "Kvinna",
    male: "Man",

    member: "Medlem",

    changeAssociation: "Byt förening",
    selectAssociation: "Välj förening",
    unselectAssociation: "Välj bort förening",

    menu_user: "Användare",
    menu_home: "Hem",
    menu_settings: "Inställningar",
    menu_association_register: "Föreningsregister",
    menu_person: "Personer",
    menu_activity: "Verksamheter",
    menu_logs: "Loggning",
    menu_themes: "Färgtema",
    menu_association_attendance: "Förening/Närvaro",
    menu_groups_attendance: "Grupper/Närvaro",

    download: "Ladda ner",
    downloaded: "Nedladdad",
    fetched: "Hämtad",
    fetchedByContributionSystem: "Hämtad av bidragssystem",

    formChangedMessage: "Formuläret är ändrat men inte sparat. Dina ändringar kommer att försvinna om du fortsätter utan att spara först. Vill du fortsätta?",

    unreadMessages: "Olästa meddelanden",
    attendance: "Närvaro",
    back: "Tillbaka",
    logs: "Loggar",

    municipalityLogoType: "Kommunens logotype",
   
    batch: {
        statisticsAndExport: "Statistik/Export",
        batchState: "Status",
        Pending: "Väntar",
        Running: "Körs",
        Done: "Klar",
        Error: "Fel",

        contributionFiles: "Bidragsfiler",
        exportFiles: "Exportfiler",
        generateExportFileFor: "Generera exportfil för ",

        existingExportFileWillBeReplaced: "Vid generering kommer existerande exportfil för perioden att tas bort.",
        existingExportFileIsLocked: "Bidragsperiodens fil är redan exporterad. Kontakta kommunen om filen ska ersättas.",

        exportGroups: "Grupper för export",
        exportOccasions: "Gruppaktiviteter för export",
    },

    association: {
        association: "Förening",       
        AssociationGroupAdmin: "Gruppadmin",
        AssociationAdmin: "Föreningsadmin",
        registerAssociation: "Registrera förening",
        name: "Föreningsnamn",
        orgNo: "Organisationsnummer",
        editAssociation: "Ändra föreningsuppgifter",
        pageHeader: "Föreningsregister",
        nameAlreadyExists: "Det finns redan en förening med namnet",
        orgNoAlreadyExists: "Det finns redan en förening med organisationsnummer",
        externalIdAlreadyExists: "Det finns redan en förening med externtId",
        externalId: "Externt Id",
        administrateAssociation: "Administrera förening",
        administrateGroups: "Administrera grupper",
        associationsActivities: "Föreningens verksamheter",

    },

    contributionPeriod: {
        contributionPeriod: "Bidragsperiod",
        contributionPeriods: "Bidragsperioder",
        editContributionPeriod: "Ändra bidragsperiod",
        lastRegistrationDate: "Sista ansökningsdatum",
    },

    confirmUser: {
        newPassword: "Ange nytt lösenord",
        repeatNewPassword: "Upprepa nytt lösenord",
        passwordUpdatedMessage: "Lösenordet har uppdaterats.",
        emailVerifiedMessage: "Epostadressen är verifierad.",
        sendingToLoginPageMessage: "Du skickas nu till login-sidan.",
        passwordDoesNotMatch: "Lösenorden är inte lika."
    },

    applicationsetting: {
        AccessibilityStatementUrl: "Tillgänglighetsredogörelse",
        Municipality: "Kommunkod",
        IsSSNMandatory: "Fullständigt personnummer krävs",
        FormatOfDateOfBirth: "Format på födelsedatum",
        ZipCodeVisibleAndMandatory: "Postnr ska anges",
        CityVisibleAndMandatory: "Postort ska anges",
        MailO365ClientId: "Program-ID (klient)",
        MailO365TenantId: "Katalog - ID (klientorganisation)",
        MailO365ServerUserName: "Användarnamn",
        MailO365ServerUserPassword: "Lösenord",
        ApplicationSettingsHeadline: "Applikationsinställningar",
        ParticipantSettingsHeadline: "Inställningar för personregister",
        MaílServerSettingsHeadline: "Inställningar mailserver",
        MiscellaneousHeadline: "Övrigt",
        MunicipalityName: "Kommunnamn",
        MunicipalityLogo: "Kommunlogga",
        SaveLogoType: "Spara logga",
        RemoveLogoTypeImage: "Ta bort logga",
        MaxNumberOfAssociations: "Max antal aktiva föreningar (blankt = ingen gräns)",
    },
    logType: {
        logLevel: "Loggnivå",
        logTypes: "Loggtyper",
        logType: "Loggtyp",
        Trace: "Trace",
        Debug: "Debug",
        Information: "Information",
        Warning: "Warning",
        Error: "Error",
        Critical: "Critical",
        None: "None",
        System: "System",
        User: "Användare",
        Association: "Förening",
        Group: "Grupp",
        Person: "Person",
        Occasion: "Gruppaktivitet",
        ExportFile: "Exportfil",
        Batch: "Batchjobb",
        editLogLevel: "Ändra loggnivå",
        logTypeSettings: "Inställningar för loggning",
    },
    person: {
        hasNoSwedishSsn: "Saknar svenskt personnummer",
        isDisabled: "Funktionsnedsatt",
        firstName: "Förnamn",
        lastName: "Efternamn",
        socialSecurityNumber: "Personnummer",
        gender: "Juridiskt kön",
        email: "E-post",
        mobile: "Mobilnummer",
        telephoneNumber: "Telefonnummer",
        zipCode: "Postnummer",
        city: "Postort",
        role: 'Roll',
        address: 'Adress',
        isLeader: "Ledare",
        registerNewPerson: "Registrera person",
        searchPersonRegister: "Sök i personregister",

        editPerson: "Ändra uppgifter på person",
        pageHeader: "Personer",
        persons: "Personer",
        dateOfBirth: "Födelsedatum",
        SSNAlreadyExists: "Det finns redan en person registrerad med personnummer",
        createUserHeadline: "Skapa inloggning om personen är föreningsadministratör eller gruppadministratör (ledare)",
        noLogin: "Ingen inloggning",
        emailWillBeUpdatedInformation: "OBSERVERA! Vid byte av e-postadress kommer e-postadressen i inloggninguppgifterna ändras. Är inloggningen kopplad till flera föreningar ändras e-postadressen även där.",
        loginVerified: "Inloggning verifierad",
        emailAlreadyUsedForAUserRemoveAndAddMessage: "Det finns redan en inloggning med den här e-postadressen kopplad. Ta bort bort inloggning för den här personen och spara. Byt till den nya e-postadressen samt välj roll, spara.",
        groups: "Grupper",
        mandatoryDataIsMissing: "Obligatoriska uppgifter saknas",
        sendNewConfirmEmail: "Skicka nytt verifieringsmail",
        invalidPhoneNumber: "Felaktigt telefonnummer",
        invalidSSN: "Ogiltigt personnummer.",
        invalidDate: "Ogiltigt datum",
        emailIsMissingCannotCreateAdmin: "Personen saknar e-post, det måste finnas för att skapa admin",
        deletePerson: "Ta bort person"
    },
    group: {
        groupHead: '{0} grupp',
        groupName: "Grupp",
        groups: "Grupper",
        isLeader: "Ledare",
        isDisabledShort: "Funktionsned.",
        isAdmin: "Gruppadmin",
        participants: "Deltagare",
        leaders: "Ledare",
        addParticipantGroup: "Lägg till person",
        addParticipantGroups: "Lägg till personer",
        showGroup: "Visa grupp",
        participantGroups: "Personer",
        additionalInfoDelete: "Bekräftade gruppaktiviteter kommer inte att tas bort när gruppen tas bort",
        additionalInfoDeleteParticipant: "Personen kommer inte att tas bort från gruppaktiviteter som har passerats i tid",
        nameAlreadyExists: "Det finns redan en grupp med namnet",  
        groupNameToLong: "Gruppnamn får inte vara längre än 50 tecken",
    },
    occasion: {
        createOccasion: "Skapa gruppaktivitet",
        editOccasion: "Ändra gruppaktivitet",
        recurringOccasion: "Återkommande gruppaktivitet",
        unconfirmed: "Obekräftade",
        addPerson: "Lägg till person",
        coming: "Kommande",
        confirmed: "Bekräftade",
        occasions: "Gruppaktiviteter",
        unconfirmedOccasions: "Obekräftade gruppaktiviteter",
        comingOccasions: "Kommande gruppaktiviteter",
        confirmedOccasions: "Bekräftade gruppaktiviteter",
        pageHeader: "Närvaroregistrering",
        location: "Plats",
        occasionType: "Typ av gruppaktivitet",
        recurring: "Återkommande",
        frequency: "Frekvens",
        confirmParticipants: "Bekräfta deltagare",
        unconfirmParticipants: "Redigera närvaro",
        confirmOccasionText: "Bekräfta valda deltagare och ledare. Du kan ta tillbaka bekräftelsen för att rätta/ändra uppgifterna.",
        personDisabled: "Funktionsnedsatt", // flytta till annat ställe där den återanvänds t.ex. när man kopplar person till grupp
        participants: "Deltagare",
        leaders: "Ledare",
        temporaryLeaderShort: "Tillf. ledare",
        isPresent: "Deltagit",
        searchPersonRegister: "Sök efter befintliga personer i personregistret",
        hideField: "Göm fält",
        showField: "Visa fler fält",
        occasionsInSeries: "Gruppaktiviteter i serien",

        addGuest: "Lägg till gäst",
        removeGuest: "Ta bort gäst",
        guest: "Gäst",        

        EveryWeek: "Varje vecka",
        EveryOtherWeek: "Varannan vecka",
        EveryFourthWeek: "Var fjärde vecka",

        Training: "Träning",
        Game: "Match",
        Meeting: "Möte",
        Other: "Övrigt",

        removeOccasionAndFollowingDialogText: "Gruppaktiviteten är en del av en återkommande serie gruppaktiviteter.",
        removeOccasion: "Ta bort gruppaktiviteten",
        removeOccasionAndFollowing: "Ta bort gruppaktiviteten och alla efterföljande i serien",

        participantsConfirmed: "Bekräftad",
        participantsConfirmedBy: "Bekräftad av",

        numberOfParticipants: "Antal deltagare",
        numberOfLeaders: "Antal ledare",
        personMandatoryDataIsMissing: "Personuppgifter måste kompletteras",
        personMandatoryDataIsMissingInfo: "Det saknas obligatoriska personuppgifter på en/flera personer, för att kunna bekräfta deltagarna måste uppgifterna kompletteras.",
        addPersonToGroup: "Lägg till person i grupp",
        addPersonToGroupText: "Ska personen läggas till tillfälligt för denna sammankomst eller permanent i gruppen?",
        optionTemporary: "Tillfälligt för denna sammankomst",
        optionGroup: "Lägg till i gruppen",
        registerAttendance: "Registrera närvaro",
        confirmAttendance: "Bekräfta närvaro",
    },
    activity: {
        activityName: "Verksamhet",
        activity: "Verksamhet",
        addActivity: "Lägg till verksamhet",
        editActivity: "Ändra verksamhet",
        sSN: "Fullständigt personnummer obligatoriskt",
        incompleteSSNAllowed: "Ej fullständiga personnummer tillåts",
        completeSSNMandatory: "Fullständigt personnummer"
    },

    importPersons: {
        NoFileUploaded: "Ingen fil vald",
        importExcel: "Importera från excel",
        importPersonStatus: "Status",
        save: "Importera",
        NoPersonsSelected: "Inga personer valda",
        read: "Läs in",
        selectfile: "Välj fil",
        downloadExampelfile: "Hämta exempelfil",
    },

    importPersonStatus: {
        New: "Ny",
        IsChanged: "Ändrad",
        ExistAndNothingChanged: "Oförändrad, ingen uppdatering görs",
        SocialSecurityNoInvalid: "Ogiltigt personnummer",
        AssociationUserAndEmailChanged: "Inloggning finns och e-post ändrad. Uppdatering får göras via personregister"
    },

    user: {
        selectAssociationUser: "Välj förening/roll",
        associationUserId: "Förening/roll",
        AssociationUser: "Föreningsanvändare",
        SystemAdmin: "Systemadmin",
        MunicipalityAdmin: "Kommunadmin",
        registerAdministrator: "Registrera administratör",
        emailConfirmed: "Epost verifierad",
        userCreatedMessage: "Användare sparad och aktiveringsmail skickat.",
        removedMessage: "Användaren borttagen.",
        sendConfirmEmail: "Skicka verifieringsmail",
        confirmEmailSent: "Verifieringsmail skickat",
        admins: "Administratörer",
        associationUsers: "Föreningsanvändare",
        forgotPassword: "Inget eller glömt lösenord?",
        resetPassword: "Aktivera konto/återställ lösenord",
        resetPasswordSent: "Om epostadressen finns registrerad så har ett meddelande skickats för återställning av lösenordet.",
        oldPassword: "Nuvarande lösenord",
        changePassword: "Ändra lösenord",
        passwordChanged: "Lösenord ändrat",
    },

/*    subgroup: {
        key3: "nyckel 3"
    }*/
}